/** @jsxImportSource @emotion/react */
import {useEffect, useState} from 'react'
import {Typography} from 'antd'
import DraggableModal from 'components/DraggableModal/DraggableModal.jsx'
import Tools from "script/sweet-tools.mjs";
import FlowTaskActive from "./FlowTaskActive";
import FlowTaskHistory from "./FlowTaskHistory";
const {Text} = Typography;
const Pane = ({
                  billId,
                  visible,
                  setVisible,
                  ...props
              }) => {
    return (
        <DraggableModal
            title="审批流程实时进度"
            okText="确定"
            cancelButtonProps={{style: {display: 'none'}}}
            // width={600}
            bodyStyle={{overflow: 'auto', maxHeight: '60vh'}}
            visible={visible}
            onOk={() => setVisible(false)}
            destroyOnClose={true}
        >
            <FlowTaskHistory billId={billId}/>
        </DraggableModal>
    )
}

export default Pane
